var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcClose = function SvgIcClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_close")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5054662,0.33752524 C23.107918,-0.147126387 23.9914187,-0.109845492 24.5506321,0.449367923 C25.1497893,1.04852515 25.1497893,2.01995096 24.5506321,2.61910819 L24.5506321,2.61910819 L14.67,12.5 L24.5506321,22.3808918 C25.1497893,22.980049 25.1497893,23.9514748 24.5506321,24.5506321 C23.9914187,25.1098455 23.107918,25.1471264 22.5054662,24.6624748 L22.3808918,24.5506321 L12.5,14.67 L2.61910819,24.5506321 L2.49453377,24.6624748 C1.89208205,25.1471264 1.00858134,25.1098455 0.449367923,24.5506321 C-0.149789308,23.9514748 -0.149789308,22.980049 0.449367923,22.3808918 L0.449367923,22.3808918 L10.33,12.5 L0.449367923,2.61910819 C-0.149789308,2.01995096 -0.149789308,1.04852515 0.449367923,0.449367923 C1.00858134,-0.109845492 1.89208205,-0.147126387 2.49453377,0.33752524 L2.61910819,0.449367923 L12.5,10.33 L22.3808918,0.449367923 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_close.44b43169.svg";
export { ForwardRef as ReactComponent };